import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import store from './store';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {StripeProvider} from 'react-stripe-elements';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

const muiTheme = getMuiTheme({
    palette: {
        primary1Color: "#33145b",
        accent1Color: "#892f31",
        textColor: "#33145b",
    },
})

const testkey = "pk_test_D143leK9fy9BXWNfDr9gOljR"
const sonderkey = "pk_live_L3Bp27WU8FdLswKDI3TwgDpQ"

ReactDOM.render(
    <Provider store={store}>
        <StripeProvider apiKey={sonderkey}>
            <MuiThemeProvider muiTheme={muiTheme}>
                <App/>
            </MuiThemeProvider>
        </StripeProvider>
    </Provider>,
    document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js